import { render, staticRenderFns } from "./ClientView.vue?vue&type=template&id=58ac8169&scoped=true"
import script from "./ClientView.vue?vue&type=script&lang=ts"
export * from "./ClientView.vue?vue&type=script&lang=ts"
import style0 from "./ClientView.vue?vue&type=style&index=0&id=58ac8169&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ac8169",
  null
  
)

export default component.exports